import src from "IMAGE";
export default { src, width: 200, height: 40, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AGllmIF9qYF9qIF+poWCqLzHr8LhhLjccQCSjrSRjbOWk7eRjbOCfamyvKy/33++337Ich22h1Q++wAAAABJRU5ErkJggg=="};
